import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlServidor } from '../util/url-servidor';
import { Observable } from 'rxjs';
import { EventoCalendarioAgenda } from '../api/dto/evento-calendario-agenda';

@Injectable({
    providedIn: 'root'
})
export class CalendarioAgendaService {

    constructor(private http: HttpClient) { }

     private url: string = UrlServidor.URL_BASE + 'agenda-empresa/eventos';
    
     listarPorDataRegitro(dataRegistro: Date, idsProfissionais: number[]): Observable<EventoCalendarioAgenda[]> {
        const request = {
            idsProfissionais
        }
        return this.http.post<any[]>(this.url + "/" + dataRegistro?.toISOString(), request);
    }
}